module.exports = __webpack_public_path__ + "media/images/courseware_d2l_courses_icon-26272722a4a36c2a1f5c913b9487fd7b.png";